// extracted by mini-css-extract-plugin
module.exports = {"root":"index-module--root--2_f2Q","container":"index-module--container--2XY7R","title":"index-module--title--2id85","content":"index-module--content--2LQjm"};